import { FileDownload } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import ListingsDataGrid from "components/Listings/ListingsDataGrid";
import useTableExport from "hooks/useTableExport";
import { Route, Routes } from "react-router-dom";
import { PageActions, PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";

const IndexElement = () => {
  const { isLoading, confirmExportModal, setOpenConfirmModal } = useTableExport({ url: `/listings_export` });

  return (
    <FullPagePaperLayout>
      {confirmExportModal}
      <PageBreadcrumbs links={[{ label: "Resale" }]} />
      <PageTitle>Listings</PageTitle>
      <PageActions>
        <Button
          variant="contained"
          startIcon={isLoading ? <CircularProgress size={24} /> : <FileDownload />}
          onClick={() => setOpenConfirmModal(true)}
          disabled={isLoading}
        >
          Export Listings
        </Button>
      </PageActions>
      <ListingsDataGrid />
    </FullPagePaperLayout>
  );
};

export default function ListingsPage() {
  return (
    <Routes>
      <Route index element={<IndexElement />} />
    </Routes>
  );
}
